import request from '../../axios';

const getAdvertisementDetail = async (guid: string, type: string) => {
  const {data}: {data: IAdvertisementDetail} = await request.get(
    `api/v2/store/advertisement-view/${guid}?ad_type=${type}`,
  );

  return data;
};

export {getAdvertisementDetail};

const getRequirementDetail = async (guid: string, type: string) => {
  const {data}: {data: IAdvertisementDetail} = await request.get(
    `api/v2/wanted/requirement-view/${guid}?requirement_type=${type}`,
  );

  return data;
};

export {getRequirementDetail};
